import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    VulnerabilityViewType,
    setActiveCategory,
} from '../../../../redux/vulnerabilities/sliceVulnerabilities';
import { IAppReduxStore } from '../../../../redux/store';
import { Button, Stack, SxProps } from '@mui/material';
import { vars } from '../../../../Theme';

/**
 * Component that shows the category structure of a user's vulnerabilities.
 */
export default () => {
    
    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Get relevant values from Redux store. */
    const activeCategory = useSelector(
        (store: IAppReduxStore) => store.vulnerabilities.settings.activeCategory,
    );
    const vulnerabilities = useSelector((store: IAppReduxStore) => store.vulnerabilities.data);
    const viewType = useSelector(
        (store: IAppReduxStore) => store.vulnerabilities.settings.viewType,
    );

    /**
     * Function that allows the component to update the active category in the redux store.
     * @param category - New active cagtegory.
     */
    const updateActiveCategory = (category: string) => dispatch(setActiveCategory(category));

    /**
     * SxProps SxProps for every category in the sidebar
     * @param active If the category is active/clicked.
     * @returns SxProps for every category in the sidebar
     */
    const getTreeButtonSx = (active: boolean): SxProps => ({
        fontWeight: 'bold',
        justifyContent: 'normal',
        border: 'none',
        margin: '4px 8px',
        textTransform: 'capitalize',

        bgcolor: active ? vars.bgGreen : 'transparent',
        color: active ? vars.brandGreen : vars.black,
    });

    /**
     * Gets the categories of the selected Selection.
     * @returns category values of the selected Selection.
     */
    const getSelectionCategories = (): string[] => {
        const selectionCategories = vulnerabilities.map(
            vulnerability =>
                vulnerability[
                    Object.values(VulnerabilityViewType)[viewType].toString().toLowerCase()
                ],
        );
        const sortedCategories: string[] = Array.from(new Set(selectionCategories.sort()));

        return sortedCategories;
    };

    /**
     * Maps every category for the selected view.
     * @returns Button elemment with each category for the selected view.
     */
    const renderCategories = (): JSX.Element[] => {
        return getSelectionCategories().map(category => {
            return (
                <Button
                    value={category}
                    sx={getTreeButtonSx(activeCategory == category && activeCategory !== 'All')}
                    onClick={() => updateActiveCategory(category)}
                    key={category}
                >
                    {category}
                </Button>
            );
        });
    };

    return <Stack>{renderCategories()}</Stack>;
};
